module.exports = __webpack_public_path__ + "89be70e32040fa96b0a204229e34eac3.jpg";